"use client";

import React, { useMemo } from "react";
import CountryPhonePrompt from "./CountryPhonePrompt";
import { useLanguage } from "@/contexts/LanguageContext";
import { getStrings } from "@/i18n/dictionaries";

/**
 * Component to display when user tries a Nigeria-only Flutterwave payment
 * with a non-Nigerian phone number.
 * 
 * This is a wrapper around CountryPhonePrompt with Nigeria-specific configuration
 */
export default function NigeriaPhonePrompt({ 
  onClose,
  onSwitchToStripe,
  onSwitchToBankTransfer,
  detectedPhone,
  authPhone,
  profilePhone,
  profileCountry,
  selectedPaymentCountry,
}) {
  const { locale } = useLanguage();
  const t = useMemo(() => getStrings(locale, "payment"), [locale]);
  const nigeriaConfig = {
    title: t.nigeria_phone_title,
    requiredPrefix: "+234",
    requiredCountryName: "Nigeria",
  };

  return (
    <CountryPhonePrompt
      onClose={onClose}
      onSwitchToStripe={onSwitchToStripe}
      onSwitchToBankTransfer={onSwitchToBankTransfer}
      detectedPhone={detectedPhone}
      authPhone={authPhone}
      profilePhone={profilePhone}
      profileCountry={profileCountry}
      selectedPaymentCountry={selectedPaymentCountry}
      config={nigeriaConfig}
    />
  );
}
